module.exports = __webpack_public_path__ + "img/search.c9d2c8f4.svg";